/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Machine } from './Machine';
import {
    MachineFromJSON,
    MachineFromJSONTyped,
    MachineToJSON,
} from './Machine';
import type { Page } from './Page';
import {
    PageFromJSON,
    PageFromJSONTyped,
    PageToJSON,
} from './Page';

/**
 * 
 * @export
 * @interface PageableMachines
 */
export interface PageableMachines {
    /**
     * 
     * @type {Array<Machine>}
     * @memberof PageableMachines
     */
    result: Array<Machine>;
    /**
     * 
     * @type {Page}
     * @memberof PageableMachines
     */
    page: Page;
}

/**
 * Check if a given object implements the PageableMachines interface.
 */
export function instanceOfPageableMachines(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;
    isInstance = isInstance && "page" in value;

    return isInstance;
}

export function PageableMachinesFromJSON(json: any): PageableMachines {
    return PageableMachinesFromJSONTyped(json, false);
}

export function PageableMachinesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageableMachines {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(MachineFromJSON)),
        'page': PageFromJSON(json['page']),
    };
}

export function PageableMachinesToJSON(value?: PageableMachines | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(MachineToJSON)),
        'page': PageToJSON(value.page),
    };
}

